// Utility to navigate to the login page.
// This is a simple implementation. In a real app, this might be part of a router service or hook.
export const navigateToLogin = () => {
  // Check if window is defined (to ensure it runs only in browser environment)
  if (typeof window !== 'undefined') {
    // Use a hard redirect to /login.
    // If using React Router's navigate function is preferred, this utility would need access to it (e.g. via a HOC or context).
    window.location.href = '/login';
  }
};